import {Category} from "dto/category/category"
import CategoryItemDeleteButton from "pages/admin/category/CategoryItemDeleteButton"
import CategoryUpdateButton from "pages/admin/category/CategoryUpdateButton"
import {MouseEventHandler} from "react"

type Props = {
    category: Category
    selected: boolean
    onSelect: () => void
    onEdit: MouseEventHandler
    isRoot?: boolean
}
export default function CategoryItem({category, selected, onSelect, isRoot, onEdit}: Props) {
    const {name, id} = category
    return (
        <div className="is-clickable panel-block pd20 is-flex is-justify-content-space-between" key={id}
             onClick={onSelect}>
            <div className={`is-flex ${selected && "has-text-info has-text-weight-bold"}`}>
                <span className={`panel-icon has-text-light ${selected && "has-text-info has-text-weight-bold"}`}>
                    <i className="fa fa-folder-plus" aria-hidden="true"/>
                </span>
                <p className="is-size-6 is-bold">{name}</p>
            </div>
            <div className='is-flex'>
                {id && <CategoryUpdateButton onClick={onEdit}/>}
                {id && <CategoryItemDeleteButton id={id}/>}
            </div>
        </div>
    )
}